import { render, staticRenderFns } from "./CloseBead.vue?vue&type=template&id=1bccca5b&scoped=true"
import script from "./CloseBead.vue?vue&type=script&lang=js"
export * from "./CloseBead.vue?vue&type=script&lang=js"
import style0 from "./CloseBead.vue?vue&type=style&index=0&id=1bccca5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bccca5b",
  null
  
)

export default component.exports